import { withErrorBoundary } from 'components/shared/Error/Boundary';
import Hr from 'components/shared/Hr/Hr';
import Input from 'components/shared/Input/Input';
import Select from 'components/shared/Select/Select';

const FacilityProviderForm = ({ formik, selectedState, handleSelectState, states }) => {
  return (
    <form>
      <div className="flex flex-col">
        <div className="mb-4">
          <div className="mb-1 text-base font-500 text-neutral-900">Facility Information</div>
          <p className="text-sm text-neutral-700">
            Please provide the facility information. You can provide either Facility NPI or Facility
            Atypical ID. Both fields are not required, but at least one of them should be provided.
          </p>
        </div>
        <div className="grid grid-cols-2 gap-x-3 gap-y-4">
          <Input
            label="Name"
            headerClassName="[&>*]:justify-between"
            tooltip="Facility name as enrolled with payers."
            id="facility_name"
            name="facility_name"
            placeholder="Enter facility name"
            value={formik.values.facility_name}
            onChange={formik.handleChange}
            error={formik.errors.facility_name}
          />
          <Input
            label="Facility NPI"
            type="text"
            headerClassName="[&>*]:justify-between"
            tooltip="NPI for this facility (if assigned)."
            placeholder="Enter facility NPI"
            name="facility_npi"
            value={formik.values.facility_npi}
            onChange={formik.handleChange}
            id="npi"
            error={formik.errors.facility_npi}
          />
          <Input
            label="Facility atypical ID"
            type="text"
            headerClassName="[&>*]:justify-between"
            tooltip="Only if required by specific payers."
            placeholder="Enter facility atypical ID"
            name="facility_id"
            value={formik.values.facility_id}
            onChange={formik.handleChange}
            id="facility_id"
            error={formik.errors.facility_id}
          />
        </div>
      </div>
      <Hr />
      <div className="flex flex-col">
        <div className="mb-4">
          <div className="mb-1 text-base font-500 text-neutral-900">
            Facility Address Information
          </div>
          <p className="text-sm text-neutral-700">
            Please provide the facility address information. This information is required for
            enrollment and will be used for billing and communication purposes.
          </p>
        </div>
        <div className="grid grid-cols-2 gap-x-3 gap-y-4">
          <Input
            label="Address"
            type="text"
            placeholder="Enter primary address"
            name="facility_addr_1"
            value={formik.values.facility_addr_1}
            onChange={formik.handleChange}
            id="addressFirst"
            error={formik.errors.facility_addr_1}
          />
          <Input
            label="Secondary address"
            type="text"
            placeholder="Enter secondary address"
            name="facility_addr_2"
            value={formik.values.facility_addr_2}
            onChange={formik.handleChange}
            id="addressSecond"
            error={formik.errors.facility_addr_2}
          />
          <Input
            label="City"
            type="text"
            placeholder="Enter city"
            name="facility_city"
            value={formik.values.facility_city}
            onChange={formik.handleChange}
            id="facility_city"
            error={formik.errors.facility_city}
          />
          <Select
            label="State"
            menuPortalTarget={document.body}
            placeholder="Type and select state"
            value={selectedState}
            onChange={(value) => handleSelectState(value)}
            options={states}
            inputId="state"
            error={formik.errors.facility_state}
          />
          <Input
            label="Zip code"
            type="text"
            placeholder="Enter zip code"
            name="facility_zip"
            value={formik.values.facility_zip}
            onChange={formik.handleChange}
            id="zipCode"
            error={formik.errors.facility_zip}
          />
        </div>
      </div>
    </form>
  );
};

export default withErrorBoundary(FacilityProviderForm);
